module.exports = __webpack_public_path__ + "static/media/app-snapshot-terminal.37828320.png";